import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { fade } from 'material-ui/utils/colorManipulator';
import {
  scienceBlue,
  redApple,
  blueGray,
  blueGray80,
  solidWhite,
  ifitBlack
} from './colors';

export default getMuiTheme({
  palette: {
    primary1Color: scienceBlue,
    primary2Color: scienceBlue,
    primary3Color: blueGray80,
    accent1Color: redApple,
    accent2Color: blueGray,
    accent3Color: blueGray,
    textColor: blueGray80,
    alternateTextColor: solidWhite,
    canvasColor: solidWhite,
    disabledColor: fade(ifitBlack, 0.3),
    shadowColor: ifitBlack,
    pickerHeaderColor: scienceBlue,
  }
});
